import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {  Image } from "../../../../Styles/style";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import image1 from "../../../../../assets/Images/percent.png";
import image2 from "../../../../../assets/Images/drop.png";
import image3 from "../../../../../assets/Images/contact.png";

const ContinerWraper = styled(Container)`
  position: relative;
  height: auto;
  width: 100%;
  padding: 0 !important;
`;

const InnerGrid = styled(Grid)`
  background: #161616;
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 10px;
  width: 100%;
  border-radius: 10px;
  padding: 10px 20px;
`;
const HR = styled.hr`
  width: 100%;
  height: 2px;
  position: absolute;
  background: ${(props) => props.theme.textSecondary};
  border: none;
  top: 20%;
  left: 0;
  z-index: 0;
  @media (max-width: 899px) {
    display: none;
  }
`;
const HowItWorksSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="howitwork">
      <HR />
      <Container>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            rowGap: "20px",
            zIndex: "1",
          }}
        >
          <Grid item xs={12}>
            <SectionsHeading
              ta="center"
              fs="46px"
              fs599="46px"
              color="#FC9C00 !important"
            >
              How It Works
            </SectionsHeading>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              p: "20px 0",
              rowGap: "30px",
            }}
          >
            <Grid itemxs={12} sm={3}>
              <SectionsHeading
                ta="center"
                fs="16px"
                fs599="16px"
                color="#000000"
                sx={{
                  background: "#FC9C00",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  p: "30px",
                  width: "40px",
                  height:"40px",
                  borderRadius: "4px",
                }}
              >
                1
              </SectionsHeading>
              <SectionsHeading
                ta="left"
                fs="22px"
                fs599="22px"
                p="10px 0"
                p599="10px 0"
                p899="10px 0"
                color="#FC9C00 !important"
              >
                Deposit Your $SHIA
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="left">
                Secure the network, earn rewards, and access the future by
                staking your $SHIA tokens in our decentralized ecosystem.
              </Paragraph>
            </Grid>
            <Grid item xs={12} sm={3}>
              <SectionsHeading
                ta="center"
                fs="16px"
                fs599="16px"
                color="#000000"
                sx={{
                  background: "#FC9C00",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  p: "30px",
                  width: "40px",
                  height:"40px",
                  borderRadius: "4px",
                }}
              >
                2
              </SectionsHeading>
              <SectionsHeading
                ta="left"
                fs="22px"
                fs599="22px"
                p="10px 0"
                p599="10px 0"
                p899="10px 0"
                color="#FC9C00 !important"
              >
                Pay Fixed Borrowing Fee
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="left">
                Experience financial freedom with a clear conscience - borrow
                $ETH against your staked $SHIA tokens with a one-time fixed fee.
              </Paragraph>
            </Grid>
            <Grid item xs={12} sm={3}>
              <SectionsHeading
                ta="center"
                fs="16px"
                fs599="16px"
                color="#000000"
                sx={{
                  background: "#FC9C00",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  p: "30px",
                  width: "40px",
                  height:"40px",
                  borderRadius: "4px",
                }}
              >
                3
              </SectionsHeading>
              <SectionsHeading
                ta="left"
                fs="22px"
                fs599="22px"
                p="10px 0"
                p599="10px 0"
                p899="10px 0"
                color="#FC9C00 !important"
              >
                Claim Borrowed $ETH
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="left">
                Seize opportunities while preserving your $SHIA potential -
                easily claim your borrowed $ETH, and take charge of your DeFi
                journey.
              </Paragraph>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{p:"20px 0"}}>
            <SectionsHeading
              ta="center"
              fs="16px"
              fs599="16px"
              color="#FC9C00 !important"
            >
              Our Values
            </SectionsHeading>
          </Grid>
          <InnerGrid item xs={12} sm={8}>
            <Image mw="40px"   src={image1} />
            <SectionsHeading ta="left" fs="20px" fs599="20px">
              110% Collateral Ratio
            </SectionsHeading>
          </InnerGrid>
          <InnerGrid item xs={12} sm={8}>
            <Image mw="40px" src={image2} />
            <SectionsHeading ta="left" fs="20px" fs599="20px">
              Efficient Liquidations
            </SectionsHeading>
          </InnerGrid>
          <InnerGrid item xs={12} sm={8}   sx={{pb:"40px"}}>
            <Image mw="40px" src={image3} />
            <SectionsHeading ta="left" fs="20px" fs599="20px">
              Account Overview
            </SectionsHeading>
          </InnerGrid>
        </Grid>
      </Container>
    </ContinerWraper>
  );
};

export default HowItWorksSection;
